'use client';

import { SWRConfig } from 'swr';
import fetchJson from '@/lib/fetch/fetch-json';
import { ThemeProvider } from '@/components/theme/theme-provider';
import { Toaster } from '@/components/ui/toaster';
import AuthWrapper from '@/components/elements/wrappers/authWrapper';
import Layout from '@/components/layouts/defaultLayout';
import { TRPCProvider } from '@/lib/trpc/trpc';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <TRPCProvider>
      <SWRConfig
        value={{ fetcher: fetchJson, onError: (e) => console.error(e) }}
      >
        <ThemeProvider
          attribute='class'
          defaultTheme='system'
          enableSystem
          disableTransitionOnChange
        >
          <AuthWrapper>
            <Layout>
              {children}
              <Toaster />
            </Layout>
          </AuthWrapper>
        </ThemeProvider>
      </SWRConfig>
    </TRPCProvider>
  );
}
